import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

function StatisticMobile() {
    const history = useHistory()
    return ( 
        <StatisticMobileStyle>
            

        </StatisticMobileStyle>
    );
}
const StatisticMobileStyle = styled.div`
    width: 100%;
    background-color: #313131;
    padding: 0 24px;


`
export default StatisticMobile;


// WEBPACK FOOTER //
// ./src/artist-ui/Statistic/StatisticMobile.js